import React from 'react';
import { Icon } from './Icon.js';
export const IconSplitViewFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V8.25C12 9.76878 10.7688 11 9.25 11H2.75C1.23122 11 0 9.76878 0 8.25V3.75C0 2.23122 1.23122 1 2.75 1H9.25ZM2.75 2.5C2.05964 2.5 1.5 3.05964 1.5 3.75V8.25C1.5 8.94036 2.05964 9.5 2.75 9.5H6V2.5H2.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconSplitViewFill12.js.map